export function underscoreReplace(string, options = { toLower: true }) {
  if (string !== undefined) {
    const newString = string.replace(/[_]/g, "-");

    return options.toLower ? newString.toLowerCase() : newString;
  }

  return string;
}
